import dataFetcher from "../dataFetcher";

export const getContainerPositionService = async () => {
  try {
    const res = await dataFetcher.get("/poscontenedor/obtenerposcontenedores");
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data,
    };
  }
};

export const updateContainerPositionsService = async (newPositions, codigo_posicion, log_usu_id) => {
  try {
    const res = await dataFetcher.post(
      "/poscontenedor/ordenarposcontenedores",
      { contenedores: newPositions, codigo_posicion, log_usu_id: Number(log_usu_id) }
    );
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data,
    };
  }
};

// SALIDAS

export const getOutputContainerPositionService = async () => {
  try {
    const res = await dataFetcher.get(
      "/poscontenedor/obtenerposcontenedoressalidas"
    );
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data,
    };
  }
};

export const updateOutputContainerPositionsService = async (newPositions) => {
  try {
    const res = await dataFetcher.post(
      "/poscontenedor/ordenarposcontenedoressalidas",
      { contenedores: newPositions }
    );
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data,
    };
  }
};
